import { render, staticRenderFns } from "./RequestGrid.vue?vue&type=template&id=6b6824ee"
import script from "./RequestGrid.vue?vue&type=script&lang=js"
export * from "./RequestGrid.vue?vue&type=script&lang=js"
import style0 from "./RequestGrid.vue?vue&type=style&index=0&id=6b6824ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports